/* tslint:disable:variable-name */
export class TxInfocenterUser {
	constructor(
		public Personalnummer: number,
		public Name: string,
		public Abteilung: string,
		public Gruppe: string,
		public Status: string,
		public Tagesinfo: string,
		public FehlzeitId: string,
		public FehlzeitName: string,
		public LetzteBuchungsZeit: string,
		public LetzterBuchungsTyp: string,
		public AuftragAktiv: number,
		public AuftragsNummer: string,
		public AuftragsBezeichnung: string,
		public AuftragsschrittNummer: string,
		public AuftragsschrittBezeichnung: string,
		public AuftragsBuchung: string,
		public InfoDatum: string,
		public state_text: string,
		// Delivered by getInfocenter only once the webservice has been extended. Optional on
		// purpose: without them the team filter and the "my employees" switch stay hidden and
		// everything else keeps working.
		public TeamId?: number,
		public TeamName?: string,
		public IsAssignedToMe?: number
	) {}
}

export class InfocenterProtokoll {
	constructor(public statuscode: number, public statustext: string, public Infocenters: Array<TxInfocenterUser>) {
		if (Infocenters !== null && Infocenters !== undefined) {
			for (let i = 0, l = this.Infocenters.length; i < l; i++) {
				this.Infocenters[i] = new TxInfocenterUser(
					this.Infocenters[i].Personalnummer,
					this.Infocenters[i].Name,
					this.Infocenters[i].Abteilung,
					this.Infocenters[i].Gruppe,
					this.Infocenters[i].Status,
					this.Infocenters[i].Tagesinfo,
					this.Infocenters[i].FehlzeitId,
					this.Infocenters[i].FehlzeitName,
					this.Infocenters[i].LetzteBuchungsZeit,
					this.Infocenters[i].LetzterBuchungsTyp,
					this.Infocenters[i].AuftragAktiv,
					this.Infocenters[i].AuftragsNummer,
					this.Infocenters[i].AuftragsBezeichnung,
					this.Infocenters[i].AuftragsschrittNummer,
					this.Infocenters[i].AuftragsschrittBezeichnung,
					this.Infocenters[i].AuftragsBuchung,
					this.Infocenters[i].InfoDatum,
					this.Infocenters[i].state_text,
					this.Infocenters[i].TeamId,
					this.Infocenters[i].TeamName,
					this.Infocenters[i].IsAssignedToMe
				);
			}
		}
	}

	getUserInfo(aUsername: string) {
		if (this.Infocenters !== null && this.Infocenters !== undefined) {
			for (let i = 0, l = this.Infocenters.length; i < l; i++) {
				if (this.Infocenters[i].Name === aUsername) {
					return this.Infocenters[i];
				}
			}
		} else {
			return null;
		}
	}
}
